import { Close, Settings } from "@mui/icons-material";
import {
  Box,
  Drawer,
  Fab,
  FormControlLabel,
  IconButton,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import { useSearchParams } from "react-router";
import { useFeatureFlags } from "@/contexts/FeaturesContext";

export default function FeaturesPanel() {
  const { flags, setFlag, panelOpen, setPanelOpen } = useFeatureFlags();
  const [searchParams] = useSearchParams();
  const isTestMode = searchParams.has("test");

  return (
    <>
      {isTestMode && !panelOpen && (
        <Fab
          aria-label="Open demo toggles"
          size="small"
          onClick={() => setPanelOpen(true)}
          sx={{
            position: "fixed",
            top: { xs: 20, sm: 33 },
            right: { xs: 120, sm: 16 },
            zIndex: 1300,
            width: 28,
            height: 28,
            minHeight: "unset",
            bgcolor: "background.paper",
            "& .MuiSvgIcon-root": { fontSize: 16 },
          }}
        >
          <Settings />
        </Fab>
      )}
      <Drawer anchor="right" open={panelOpen} onClose={() => setPanelOpen(false)}>
        <Box sx={{ width: { xs: "100vw", sm: 500 }, p: 3 }}>
          <IconButton
            aria-label="Close demo toggles"
            size="small"
            onClick={() => setPanelOpen(false)}
            sx={{ position: "fixed", right: 10, top: 15 }}
          >
            <Close fontSize="small" />
          </IconButton>
          <Stack spacing={2}>
            <Typography variant="h3" sx={{ mb: 2.5 }}>
              Demo
            </Typography>
            <FormControlLabel
              labelPlacement="start"
              label="Demo mode (no real bookings)"
              sx={{ display: "flex", justifyContent: "space-between", mx: 0 }}
              control={
                <Switch
                  checked={flags.demoMode}
                  onChange={(e) => setFlag("demoMode", e.target.checked)}
                />
              }
            />
          </Stack>
        </Box>
      </Drawer>
    </>
  );
}
